import { TextInput } from '@makemydeal/dr-shared-components/text-input';
import { Typography } from '@interstate/components/Typography';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { useCustomerCardContext } from '../../CustomerFormContext';
import { BUSINESS_LEGAL_NAME_FIELD } from '../../../constants';
import { FieldsRow } from '../sectionLayout.styles';

/**
 * Renders the required Business Name field followed by the "Signer" heading.
 * Shown at the top of the buyer form when isBusinessBuyer is true.
 * Mirrors the legacy MV CustomerCard business-name block.
 */
const BusinessNameField = () => {
    const { formValues, formErrors, handleInputChange, isLocked, customerRole } = useCustomerCardContext();

    return (
        <>
            <FieldsRow $columns={1} $mdColumns={1} $smColumns={1}>
                <TextInput
                    label="Business Name"
                    name="business-name"
                    data-testid={`customer-form-${customerRole}-business-name`}
                    value={formValues.business?.legalName ?? ''}
                    onChange={(e) => handleInputChange(BUSINESS_LEGAL_NAME_FIELD, e.target.value)}
                    disabled={isLocked}
                    hasError={Boolean(formErrors?.business?.legalName?.hasError)}
                    errorMessage={formErrors?.business?.legalName?.errorMessage}
                    selectOnFocusSelector={featureToggleSelectors.isAutoSelectContentOnSlideOutsEnabledAfterBootstrap}
                    required
                    displayLabel
                    size="small"
                />
            </FieldsRow>
            <Typography variant="h5" sx={{ marginBottom: '1rem', marginTop: '1.5rem' }}>
                Signer
            </Typography>
        </>
    );
};

BusinessNameField.displayName = 'BusinessNameField';
export default BusinessNameField;
